import { render, staticRenderFns } from "./ControlGoal.vue?vue&type=template&id=0f0637b7&scoped=true"
import script from "./ControlGoal.vue?vue&type=script&lang=js"
export * from "./ControlGoal.vue?vue&type=script&lang=js"
import style0 from "./ControlGoal.vue?vue&type=style&index=0&id=0f0637b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0637b7",
  null
  
)

export default component.exports